<script setup>
import { format } from 'date-fns';
import BillingCard from './BillingCard.vue';

defineProps({
  submissions: { type: Array, default: () => [] },
});

const STATUS_CLASS = {
  pending: 'bg-n-amber-3 text-n-amber-11',
  approved: 'bg-n-teal-3 text-n-teal-11',
  rejected: 'bg-n-ruby-3 text-n-ruby-11',
};

const formatDate = value => format(new Date(value), 'dd MMM, yyyy');
</script>

<template>
  <BillingCard
    :title="$t('BILLING_SETTINGS.SUBMISSIONS.TITLE')"
    :description="$t('BILLING_SETTINGS.SUBMISSIONS.DESCRIPTION')"
  >
    <div class="px-5">
      <p v-if="!submissions.length" class="text-sm text-n-slate-11">
        {{ $t('BILLING_SETTINGS.SUBMISSIONS.EMPTY') }}
      </p>
      <ul v-else class="divide-y divide-n-weak">
        <li
          v-for="submission in submissions"
          :key="submission.id"
          class="flex flex-wrap items-center justify-between gap-2 py-3"
        >
          <div class="flex flex-col">
            <span class="text-sm font-medium text-n-slate-12">
              {{ submission.plan_name || submission.credits }}
            </span>
            <span class="text-xs text-n-slate-10">
              {{ formatDate(submission.created_at) }} ·
              {{ submission.currency }}
              {{ submission.amount }}
              <template v-if="submission.external_ref">
                · {{ submission.external_ref }}
              </template>
            </span>
            <span
              v-if="submission.note"
              class="text-xs"
              :class="
                submission.status === 'rejected'
                  ? 'text-n-ruby-11'
                  : 'text-n-slate-10'
              "
            >
              {{ submission.note }}
            </span>
          </div>
          <span
            class="px-2 py-0.5 text-xs font-medium rounded-full"
            :class="STATUS_CLASS[submission.status]"
          >
            {{
              $t(
                `BILLING_SETTINGS.SUBMISSIONS.STATUS.${submission.status.toUpperCase()}`
              )
            }}
          </span>
        </li>
      </ul>
    </div>
  </BillingCard>
</template>
